/**
 * Check if the two emails are considered the same.
 *
 * @param email1 first email
 * @param email2 second email
 * @return {boolean} true if they're the same
 */
export const emailsAreEqual = (email1 = '', email2 = '') => {
    return email1.toLowerCase() === email2.toLowerCase();
};

/**
 * Validation to detect an "@", followed by a dot and then a character.
 * @param {string} email
 * @return {boolean}
 */
export const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
};
